<template>
  <div>
    <v-row justify="space-between" class="mt-2 mx-2">
      <v-spacer></v-spacer>
      <v-col cols="6" md="2" sm="3">
        <download-csv :data="this.JsonFormat" :name="`${year}Revenue.csv`">
          <v-btn
            small
            rounded
            class="ml-6 btn-help-video"
            color="success"
            @click="checkJson"
          >
            CSV Export
          </v-btn>
        </download-csv>
      </v-col>
      <div class="spacer-div"></div>
      <v-col cols="6" md="2" sm="3">
        <v-select
          :items="generateArrayOfYears"
          label="Select Year"
          item-value="year"
          v-model="year"
          dense
          outlined
          @change="fetchRevenueData(year)"
        ></v-select>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>

    <v-row justify="center" class="mt-2 mx-2">
      <div>
        <v-skeleton-loader
          v-if="loader"
          :loading="loader"
          class="mb-3 mt-4"
          type="list-item-avatar-two-line,table@2"
          elevation="2"
        >
        </v-skeleton-loader>

        <v-data-table
          v-else
          :headers="Headers"
          :items="revenueData.data"
          :items-per-page="12"
          class="elevation-1 mb-5"
          mobile-breakpoint="0"
          hide-default-footer
        >
          <template v-slot:item.month="{ item }">
            <p v-if="item.month == 1">January</p>
            <p v-if="item.month == 2">February</p>
            <p v-if="item.month == 3">March</p>
            <p v-if="item.month == 4">April</p>
            <p v-if="item.month == 5">May</p>
            <p v-if="item.month == 6">June</p>
            <p v-if="item.month == 7">July</p>
            <p v-if="item.month == 8">August</p>
            <p v-if="item.month == 9">September</p>
            <p v-if="item.month == 10">October</p>
            <p v-if="item.month == 11">November</p>
            <p v-if="item.month == 12">December</p>
          </template>
        </v-data-table>
      </div>
    </v-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "revenueTable",
  props: {
    reportData: {
      type: [Array, Object],
      default: () => {},
    },
  },
  data() {
    return {
      years: [],
      JsonFormat: [],
      year: 2023,
      Headers: [
        { text: "Month-Year", value: "month" },
        { text: "New ($)", value: "new" },
        { text: "Renewal ($) ", value: "renew" },
        { text: "Total ($) ", value: "total" },
      ],
    };
  },

  created() {
    this.fetchRevenueData(this.year);
  },

  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem("role") !== "client") {
      next({ name: "Pricing" });
    } else {
      next();
    }
  },

  computed: {
    ...mapState("userModule", ["revenueData", "loader"]),

    generateArrayOfYears() {
      let max = new Date().getFullYear() - 1;
      let min = max + 9;
      let years = [];

      for (let i = max; i <= min; i++) {
        years.push(i);
      }

      console.log(years);
      return years;
    },
  },

  methods: {
    backButton() {
      this.$router.go(-1);
    },

    fetchRevenueData(year) {
      this.$store.dispatch("userModule/getRevenue", {
        year: year.toString(),
      });
    },

    returnMonthName(month) {
      switch (month) {
        case 1:
          return "January";
        case 2:
          return "February";
        case 3:
          return "March";
        case 4:
          return "April";
        case 5:
          return "May";
        case 6:
          return "June";
        case 7:
          return "July";
        case 8:
          return "August";
        case 9:
          return "September";
        case 10:
          return "October";
        case 11:
          return "November";
        case 12:
          return "December";
      }
    },

    checkJson() {
      // debugger;
      this.JsonFormat = [];
      this.JsonFormat = this.revenueData.data.map((item) => {
        let newObj = {
          month: this.returnMonthName(item.month),
          new: item.new,
          renew: item.renew,
          total: item.total,
        };

        return newObj;
      });
      console.log("JsonFormat", this.JsonFormat);
      return this.JsonFormat;
    },
  },
};
</script>

<style scoped>
.spacer-div {
  width: 140px;
}
</style>
